module.exports = __webpack_public_path__ + "static/media/vacctrak_logo_dark.906b62b0.svg";